import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e62e470")

_pushScopeId("data-v-7e62e470")
const _hoisted_1 = { class: "fridgedetailstabsitem-title" }
const _hoisted_2 = { class: "fridgedetailstabsitem-title-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "fridgedetailstabsitem",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectItem(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", {
      class: "fridgedetailstabsitem-indicator",
      style: _ctx.indicatorStyle
    }, null, 4)
  ]))
})